import { Component, Input, OnInit } from '@angular/core';
import { AppelsService } from 'src/app/modules/appels/service/appels.service';

@Component({
  selector: 'app-info-appel',
  templateUrl: './info-appel.component.html',
  styleUrls: ['./info-appel.component.css']
})
export class InfoAppelComponent implements OnInit {
  @Input() base: any;
  @Input() cohorte: any;
  infoparcours: any;

  constructor(private serviceAppel: AppelsService) { }

  ngOnInit(): void {
    this.serviceAppel.getInfobycohorte(this.base, this.cohorte).subscribe({
      next: (data) => {
        this.infoparcours = data;
      },
    });
  }


}
